import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { formatRut } from '../../../../utils/formats/formats'

const RutCell = ({ value }) => {
  return (
    <div style={{ textAlign: 'end', padding: '2px' }}>
      {formatRut(value).formatValue}
    </div>
  )
}

RutCell.propTypes = {
  value: PropTypes.string,
}

export default memo(RutCell)
